<div class="reauthorize-modal">
  <div class="modal-header">
    <mat-icon class="warning-icon">warning</mat-icon>
    <h2>Xero Authorisation Required</h2>
  </div>

  <div class="modal-content">
    <p class="info-text">
      Your Xero authorisation token has expired. To continue running invoices, please authorise the application with your Xero account.
    </p>

    <div class="status-section" *ngIf="authorizationComplete">
      <div class="success-container">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <p class="success-text">Authorisation successful!</p>
        <p class="subtitle-text">You can now close this window or it will close automatically.</p>
      </div>
    </div>

    <div class="loading-section" *ngIf="isAuthorizing && !authorizationComplete">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Opening Xero authorisation window...</p>
      <p class="subtitle-text">Please complete the authorisation in the popup window.</p>
    </div>

    <div class="manual-confirmation" *ngIf="!isAuthorizing && !authorizationComplete">
      <p class="subtitle-text">After you've authorised with Xero and closed the popup, click the button below:</p>
    </div>
  </div>

  <div class="modal-actions">
    <button 
      mat-raised-button 
      color="primary"
      (click)="startXeroAuthorization()"
      [disabled]="isAuthorizing || authorizationComplete"
      class="authorize-button">
      <mat-icon>login</mat-icon>
      Authorise with Xero
    </button>
    <button 
      mat-raised-button
      color="accent"
      (click)="confirmAuthorizationComplete()"
      [disabled]="isAuthorizing || authorizationComplete"
      *ngIf="!isAuthorizing && !authorizationComplete"
      class="confirm-button">
      <mat-icon>done</mat-icon>
      I've Authorised with Xero
    </button>
    <button 
      mat-stroked-button
      (click)="closeDialog()"
      [disabled]="isAuthorizing"
      class="cancel-button">
      Cancel
    </button>
  </div>
</div>
